export function isLaunchCertificateEligible(aggregateStatus) {
    switch (aggregateStatus) {
        case "ready":
        case "ready_with_warnings":
            return { eligible: true, reason: null };
        case "blocked":
            return { eligible: false, reason: "launch_proof_blocked" };
        case "not_evaluated":
            return { eligible: false, reason: "launch_proof_not_evaluated" };
        default:
            return { eligible: false, reason: "launch_proof_not_ready" };
    }
}
export function ineligibilityReasonLabel(reason) {
    switch (reason) {
        case "launch_proof_blocked":
            return "Launch Proof has blocking issues — certificate not issued.";
        case "launch_proof_not_evaluated":
            return "Launch Proof checks were not fully evaluated — certificate not issued.";
        case "launch_proof_not_ready":
            return "Launch Proof is not ready — certificate not issued.";
        default:
            return "Certificate not issued.";
    }
}
//# sourceMappingURL=certificate-eligibility.js.map